export function validateDetails({ name, address, latitude, longitude }, user) {
  if (!user?.uid || !/^\+91[6-9]\d{9}$/.test(user.phoneNumber || "")) throw new Error("Please log in with your mobile number first.");
  if (name.trim().length < 2 || name.trim().length > 120) throw new Error("Enter your full name (2–120 characters).");
  if (address.trim().length < 10 || address.trim().length > 1000) throw new Error("Enter a complete delivery address (10–1000 characters).");
  if ([latitude, longitude].some(value => value == null || typeof value === "boolean" || String(value).trim() === "" || !Number.isFinite(Number(value))) || Math.abs(Number(latitude)) > 90 || Math.abs(Number(longitude)) > 180) throw new Error("Use your current location or enter valid latitude and longitude.");
}

export function deliveryCharge(settings, subtotal, location, now = new Date()) {
  if (settings.deliveryEnabled !== true) throw new Error("Delivery is currently unavailable.");
  const minutes = (value, fallback) => {
    const match = /^(\d{2}):(\d{2})$/.exec(value || fallback);
    return match && +match[1] < 24 && +match[2] < 60 ? +match[1] * 60 + +match[2] : minutes(fallback, fallback);
  };
  const open = minutes(settings.storeOpenTime, "07:00");
  const close = minutes(settings.storeCloseTime, "22:00");
  const parts = new Intl.DateTimeFormat("en-GB", { timeZone: "Asia/Kolkata", hour: "2-digit", minute: "2-digit", hourCycle: "h23" }).formatToParts(now);
  const current = Number(parts.find(p => p.type === "hour").value) * 60 + Number(parts.find(p => p.type === "minute").value);
  if (open !== close && !(open < close ? current >= open && current < close : current >= open || current < close)) throw new Error("The store is currently closed. Please return during opening hours.");
  const lat = settings.hubLatitude, lng = settings.hubLongitude;
  if (!Number.isFinite(lat) || !Number.isFinite(lng) || Math.abs(lat) > 90 || Math.abs(lng) > 180) throw new Error("Delivery location is not configured. Please try later.");
  if (location) {
    if (!Number.isFinite(location.latitude) || !Number.isFinite(location.longitude)) throw new Error("Select a valid delivery location.");
    const rad = n => n * Math.PI / 180;
    const a = Math.sin(rad(location.latitude - lat) / 2) ** 2 + Math.cos(rad(lat)) * Math.cos(rad(location.latitude)) * Math.sin(rad(location.longitude - lng) / 2) ** 2;
    const distance = 6371 * 2 * Math.asin(Math.sqrt(Math.min(1, a)));
    const radius = settings.deliveryRadiusKm > 0 ? settings.deliveryRadiusKm : 5;
    if (distance > radius) throw new Error(`This location is outside our ${radius} km delivery area.`);
  }
  const free = Number.isFinite(settings.freeDeliveryMinimum) && settings.freeDeliveryMinimum >= 0 ? settings.freeDeliveryMinimum : 299;
  const charge = Number.isFinite(settings.deliveryCharge) && settings.deliveryCharge >= 0 ? settings.deliveryCharge : 30;
  return subtotal >= free ? 0 : Math.round(charge);
}

export function addressText(data) {
  return [data.line1, data.line2, data.landmark, data.city, data.state, data.pincode].filter(Boolean).join(", ");
}

export function buildOrder(user, details, quote, timestamp, orderId) {
  validateDetails(details, user);
  const name = details.name.trim(), address = details.address.trim();
  return {
    orderId, ownerUid: user.uid, ownerPhone: user.phoneNumber, ownerName: name,
    name, phone: user.phoneNumber, address, customerName: name, phoneNumber: user.phoneNumber,
    deliveryAddress: address, latitude: Number(details.latitude), longitude: Number(details.longitude),
    items: quote.items, subtotal: quote.subtotal, deliveryCharge: quote.deliveryCharge,
    totalAmount: quote.subtotal + quote.deliveryCharge,
    paymentMethod: "Cash on Delivery", paymentStatus: "Pending", status: "Pending",
    statusUpdatedAt: timestamp, statusHistory: [{ status: "Pending", updatedAt: timestamp }],
    createdAt: timestamp, ...quote.shopFields,
  };
}
